import { getElementMoleculeFormula } from './formulaUtils';
import { createBalancedEquation } from './equationUtils';

/**
 * Builds an order-independent key for a pair of substance ids,
 * so "K + H2O" and "H2O + K" find the same reaction.
 */
export function createPairKey(firstId, secondId) {
  return [firstId, secondId].sort().join('+');
}

/**
 * Balanced equation text for two substances making the given products. Elements are written
 * as their molecules (O2, Cl2); elements come before water or acid, and otherwise follow the
 * order they appear in the first product ("Na + Cl2 -> NaCl", "4P + 5O2 -> P4O10").
 */
export function buildReactionEquationText(substances, productFormulas) {
  const [firstProduct] = productFormulas;
  const sortKey = (substance) =>
    substance.isElement() ? firstProduct.search(new RegExp(`${substance.id}(?![a-z])`)) >>> 0 : Number.MAX_SAFE_INTEGER;
  const orderedSubstances = [...substances].sort((first, second) => sortKey(first) - sortKey(second));
  const reactantFormulas = orderedSubstances.map((substance) =>
    substance.isElement() ? getElementMoleculeFormula(substance.id) : substance.plainFormula
  );
  return createBalancedEquation(reactantFormulas, productFormulas).text;
}
